import { useEffect, useState } from "react";
import { WeworkServiceApi } from "./WeworkServiceApi";
import { WeworkServiceModal } from "./WeworkServiceModal";
import {
  isWeworkHomePopupDismissed,
  markWeworkHomePopupDismissed,
} from "./weworkHomePopupDismiss";
import type { WeworkServiceHomePopupData } from "./WeworkServiceType";

export function WeworkHomePopupHost(props: { spaceId: string | undefined }) {
  const { spaceId } = props;
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<WeworkServiceHomePopupData | null>(null);

  useEffect(() => {
    if (!spaceId) {
      setOpen(false);
      setData(null);
      return;
    }
    let cancelled = false;
    void (async () => {
      const res = await WeworkServiceApi.getHomePopup({ spaceId });
      if (cancelled) {
        return;
      }
      if (!res) {
        setOpen(false);
        setData(null);
        return;
      }
      if (isWeworkHomePopupDismissed(spaceId, res.popupVersion)) {
        setOpen(false);
        setData(null);
        return;
      }
      setData(res);
      setOpen(true);
    })();
    return () => {
      cancelled = true;
    };
  }, [spaceId]);

  if (!data) {
    return null;
  }

  return (
    <WeworkServiceModal
      open={open}
      title={data.title}
      content={data.content}
      card={data.card}
      showDismiss
      onClose={() => setOpen(false)}
      onDismissForever={() => {
        if (spaceId) {
          markWeworkHomePopupDismissed(spaceId, data.popupVersion);
        }
        setOpen(false);
      }}
    />
  );
}
